<span class="badge" [popoverTitle]="hierarchyTitle" [ngbPopover]="hierarchy" [ngClass]="{
        'bg-warning': currentLevel.status == 0,
        'bg-success': currentLevel.status == 1,
        'bg-danger': currentLevel.status == 2,
    }" *ngIf="currentLevel">
    {{
    currentLevel.status == 0? 'P': currentLevel.status == 1? 'A': 'R'
    }}
</span>

<ng-template #hierarchyTitle>
    <div class="d-flex justify-content-between align-items-center">
        <span>Approval Status</span>
        <span class="d-block"><i [data-feather]="'x'" size="20px"></i></span>
        <!-- (click)="closePopover()" -->
    </div>
</ng-template>

<ng-template #hierarchy>
    <ul class="timeline mt-2">
        <li class="timeline-item" *ngFor="let status of statusList">
            <span class="timeline-point timeline-point-indicator" [ngClass]="{
                'bg-warning': currentLevel?.status == 0,
                'bg-success': currentLevel?.status == 1,
                'bg-danger': currentLevel?.status == 2,
            }"></span>
            <div class="timeline-event">
                <div class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1">
                    <div>
                        <h6 class="mb-0 font-weight-bolder"><span class="my-des alt" [ngbTooltip]="status.name">{{
                                status.name }}</span></h6>
                        <small [ngbTooltip]="status.alternateEmployee" class="text-muted my-des alt"
                            *ngIf="status.alternateEmployeeId && status.alternateEmployeeId != status.employeeId">On
                            Behalf of
                            {{status.alternateEmployee}}</small>
                        <small>{{status.approvedDate}}</small>
                    </div>
                </div>
                <div>
                    <span class="badge" [ngClass]="{
                    'bg-warning': status?.status == 0,
                    'bg-success': status?.status == 1,
                    'bg-danger': status?.status == 2,
                }">
                        {{
                        status.status == 0? 'Pending': status.status == 1? 'Approved': 'Rejected'
                        }}
                    </span>
                    <span class="ml-1" *ngIf="status.status == 2 && status.comment" [ngbTooltip]="status.comment">
                        <i data-feather="info"></i>
                    </span>
                </div>
            </div>
        </li>
    </ul>
</ng-template>